import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class BomItemRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    packingCategory: string;

    @ApiProperty()
    minGrade: number;

    @ApiProperty()
    maxGrade: number;

    @ApiProperty()
    @IsNumber()
    brandId: number;

  
    @ApiProperty()

    varientId:number;
    @ApiProperty()

    pouches:number;
    @ApiProperty()

    pouchWeight:number;
    @ApiProperty()
    sizeId?:number;

    @ApiProperty()
    uomId?:number;

    @ApiProperty()
    isActive?: boolean;
    @ApiProperty()
    brandsData?: any;

    @ApiProperty()
    foodType?: number;
    @ApiProperty()
    valueAdditionOneId?: number;
    @ApiProperty()
    valueAdditionTwoId?: number;
    @ApiProperty()
    valueAdditionThreeId?: number;
    @ApiProperty()
    valueAdditionFourId?: number;
    @ApiProperty()
    valueAdditionFiveId?: number;
    @ApiProperty()
    productId?: number;
    @ApiProperty()
    bapNo?: string;
}